import { render, staticRenderFns } from "./IncidentDialog.vue?vue&type=template&id=16372ad8&"
import script from "./IncidentDialog.vue?vue&type=script&lang=js&"
export * from "./IncidentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports